import React, { useState } from "react";
import { View, StyleSheet } from "react-native";

import { Calendar } from "../../common/calendar";
import Collapsible from "../../common/Collapsible/Collapsible";
import Week from "./Week";
import Utils from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";
import defaultCalendarTheme from "../../../defaultCalendarTheme";
import AutoTrackHeader from "../../common/header/AutoTrackHeader";

export default function TrackHomeCalendar({
  journalContext,
  selectedDate,
  isFromEmptyPage = false,
}) {
  const {
    controller,
    isAutoTrackMode,
    updateSelectedDate = () => {},
  } = journalContext || {};

  const [showCalendar, setShowCalendar] = useState(false);
  
  const now = Utils.nowUserTz(controller);
  const today = now.format("YYYY-MM-DD");
  
  const { week_start } = controller.state?.settings || {};
  const weekStart = week_start == "Sunday" ? 7 : 1;
  
  const onDateSelected = (sd) => {
    setShowCalendar(false);
    updateSelectedDate(sd);
  };

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  return (
    <View style={styles.container}>
      {isAutoTrackMode && !isFromEmptyPage ? (
        <AutoTrackHeader context={journalContext} />
      ) : null}

      <Week
        journalContext={journalContext}
        selectedDate={selectedDate}
        hideWeekSelector={showCalendar}
        updateSelectedDate={updateSelectedDate}
        toggleCalendar={toggleCalendar}
      />

      <Collapsible isCollapsed={!showCalendar}>
        <Calendar
          theme={defaultCalendarTheme}
          markedDates={{
            [today]: {
              marked: true,
              dotColor: "#925BE8",
              color: "#000",
            },
            [selectedDate]: {
              selected: true,
              backgroundColor: AppTheme.DEFAULT_COLOR,
              color: "#FFF",
            },
          }}
          current={today}
          maxDate={today}
          monthFormat={"MMMM yyyy"}
          onDayPress={(day) => onDateSelected(day.dateString)}
          firstDay={weekStart}
          /* onMonthChange={(month) => onMonthChanged(month)} */
          /* disableArrowRight={true} */
          /* disableMonthChange={true} */
        />
      </Collapsible>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    zIndex: 1,
    backgroundColor: AppTheme.DEFAULT_COLOR,
  },
});
